import { HeaderContext } from '@tanstack/react-table';
import { Campaign } from 'types/domain';

type CampaignTableKey = keyof Campaign;

const curriedTransformTableKeyToReadable = (header: HeaderContext<Campaign, unknown>) =>
    transformTableKeyToReadable(header.column.id as CampaignTableKey);

const transformTableKeyToReadable = (key: keyof Campaign) => {
    switch (key) {
        case 'title':
            return 'Campaign';
        case 'code':
            return 'Code';
        case 'donors':
            return 'Supporters';
        case 'raised':
            return 'Raised';
        case 'active':
            return 'Status';
        case 'url':
            return 'URL';
        case 'created_at':
            return 'Created';
        default:
            return key;
    }
};

export { transformTableKeyToReadable, curriedTransformTableKeyToReadable };
export type { CampaignTableKey };
